module.exports = {"api":"https://api.mobileadvokat.ru/api/","domain":"mobileadvokat.ru","version":"1.2.4","lk":"https://lk.mobileadvokat.ru","socket":"https://socket.mobileadvokat.ru:443"}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = 78
// module chunks = 2